// extracted by mini-css-extract-plugin
export default {"orderCard":"WorkOrderInfo_orderCard__O5Lw2","detailsGrid":"WorkOrderInfo_detailsGrid__8S53j"};